export default "__VITE_ASSET__CIx_5uNh__"